import get_restricted_dates from '../../api/dates/_restricted-dates';
let debounce = require('debounce');
import swal from 'sweetalert';

//this indicates the code's initialization status
let rd_initialized = false;

//this will hold our restricted dates when we fetch them
let restricted_dates = false;

document.addEventListener("DOMContentLoaded", function() {

	//for each of the following events, we will add a listener to trigger the init function
	['scroll', 'mousedown', 'mousemove', 'mouseover', 'keydown'].forEach(function(event) {

		//add our quick function (to check initialized status)
		window.addEventListener(event, () => { rd_initialized === false ? restricted_dates_init() : null }, false);
	});
});

async function restricted_dates_init() {

	//mark the instance as beginning initialization
	rd_initialized = true;

	//check to see if we have any restricted dates stored in cache
	let cached_dates = sessionStorage['bt_restricted_dates'];

	//if we have the dates stored in cache
	if(cached_dates) {

		//fetch from the cache and store as our variable
		restricted_dates = JSON.parse(cached_dates);
	} else {

		//fetch our restricted dates from the API and store them in session
		restricted_dates = await get_restricted_dates();

		//store this data in the cache
		sessionStorage['bt_restricted_dates'] = JSON.stringify(restricted_dates);
	}

	//if after data retrieval we have a working list of dates
	if(restricted_dates) {

		//fetch all restricted date inputs on this page
		let restricted_date_fields = document.querySelectorAll('input[name="preferred_date"]');

		//if we have some restricted date fields to loop over
		if(restricted_date_fields && restricted_date_fields.length > 0) {

			//define our function that we will attach to each field via a listener
			function check_restricted_date_field(event) {

				//fetch the newly chosen date from this input
				let chosen_date = event.target.value;

				//attempt to identify the parent form this input belongs to
				let parent_form = (event.target).closest('.frm-fluent-form');

				//if we have a date and access to the parent form
				if(chosen_date && parent_form) {

					//attempt to find both our AM and PM pickers
					let am_picker = parent_form.querySelector('input[name="preferred_time"][value="AM"]');
					let pm_picker = parent_form.querySelector('input[name="preferred_time"][value="PM"]');

					//if we have access to both pickers
					if(am_picker && pm_picker) {

						//loop over both of our pickers
						[am_picker, pm_picker].forEach(am_pm_picker => {

							//uncheck this input
							am_pm_picker.checked = false;

							//enable this input
							am_pm_picker.disabled = false;

							//remove the active class
							am_pm_picker.parentNode.parentNode.classList.remove('ff_item_selected');

							//remove the opacity class (if present)
							am_pm_picker.parentNode.parentNode.classList.remove('opacity-25');
						});

						//include the moment.js library
						let moment = require('moment');

						//reformat our chosen date with moment.js
						chosen_date = moment(chosen_date, 'DD/MM/YYYY');

						//if moment.js did it's thing...
						if(chosen_date) {

							//reformat into what the API is sending us
							chosen_date = chosen_date.format('DD-MM-YYYY');

							//if the re-formatting worked
							if(chosen_date) {

								//we'll flip this to true if we've found and made a chance
								let found = false;

								//if we have some restricted dates to loop over
								if(restricted_dates && restricted_dates.length > 0) {

									//loop over our restricted dates
									restricted_dates.forEach(date => {

										if(found) {
											return;
										}

										//if the chosen date exists in the restricted date array
										if(date.restricted_date == chosen_date) {

											//indicate the date has been found
											found = true;

											//depending on the restriction applied to this date...
											switch(date.restrict) {

												//if it's am...
												case 'AM':
													am_picker.disabled = true;
													am_picker.parentNode.parentNode.classList.add('opacity-25');
													break;

												//if it's pm...
												case 'PM':
													pm_picker.disabled = true;
													pm_picker.parentNode.parentNode.classList.add('opacity-25');
													break;

												//if the whole date is restricted...
												case 'All':
													//loop over both of our pickers
													[am_picker, pm_picker].forEach(am_pm_picker => {
														am_pm_picker.disabled = true;
														am_pm_picker.parentNode.parentNode.classList.add('opacity-25');
													});

                                                    //create an error notification
                                                    swal({
                                                        title: 'Your chosen date is unavailable',
                                                        text: "It looks like we're unable to provide service on the day you've chosen. Please choose an alternative day.",
                                                        timer: 6000
                                                    });

													break;
											}
										}
									});
								}
							}
						}
					}
				}
			}

            function disable_short_notice_days(event) {

                //check for an open flatpickr instance
                let flatpickr = document.querySelector('.flatpickr-calendar.open');

                //if we have one
                if(flatpickr) {

                    //find the current day
                    let current_day = flatpickr.querySelector('.flatpickr-day.today');

                    //if we've found the current day
                    if(current_day) {

                        //use the aria label format to get the date
                        let date = new Date(current_day.getAttribute('aria-label'));
                        let current_time = new Date();

                        //if the current day is Saturday OR it's Friday after 12pm
                        if(date.getDay() === 6 || date.getDay() === 5 && current_time.getHours() >= 12) {

                            //start with the current day
                            let next_day = current_day;

                            //defaults to 2 days
                            let days_to_disable = 2;

                            //if this is a Friday and it's after 12pm
                            if(date.getDay() === 5 && current_time.getHours() >= 12) {

                                //add an extra day to the count
                                days_to_disable = 3;
                            }

                            //loop twice to get the next siblings
                            for(let i = 0; i < days_to_disable; i++) {

                                //get the next sibling
                                next_day = next_day ? next_day.nextElementSibling : null;

                                //if we have a next day
                                if(next_day) {

                                    //disable this option
                                    next_day.classList.add('flatpickr-disabled');
                                };
                            }
                        }
                    }

                    //wait 1s...
                    setTimeout(() => {

                        //then call this function again to ensure these dates stay disabled
                        disable_short_notice_days(event);
                    }, 500);
                }

            }

			//loop over each field
			restricted_date_fields.forEach(restricted_date_field => {

				//attach our function to this field
				restricted_date_field.addEventListener('change', check_restricted_date_field, false);

                //attach our short notice day validator on the various trigger events (if applicable)
                restricted_date_field.addEventListener('click', disable_short_notice_days, false);
                restricted_date_field.addEventListener('focus', debounce(disable_short_notice_days, 250), false);
                restricted_date_field.addEventListener('keydown', debounce(disable_short_notice_days, 250), false);

				//attempt to find the container for this input
				let field_container = restricted_date_field.closest('.ff-datepicker');

				//if we have an input
				if(field_container) {

					//if the container is inside a column block
					if(field_container.parentNode.classList.contains('ff-t-cell')) {

						//add our identifier class onto the column
						(field_container.parentNode).classList.add('ff-restricted-date-toggle');
					} else { //otherwise it's on its own

						//add it to the container as planned
						field_container.classList.add('ff-restricted-date-toggle');
					}
				}
			});
		}
	}
}